import { render, staticRenderFns } from "./ImportItemModal.vue?vue&type=template&id=bd1b28f0&scoped=true"
import script from "./ImportItemModal.vue?vue&type=script&lang=js"
export * from "./ImportItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1b28f0",
  null
  
)

export default component.exports